import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class Folder extends DomainObject {
  @observable name;
  @observable createdAt;
  @observable updatedAt;
  @observable hasDocuments;
  @observable hasSubfolders;
  @observable parentId;
  @observable companyDocuments;
  @observable documents = [];
  @observable subfolders = [];
}

export default Folder;
